var map = {
	"./psn-default.png": 2148,
	"./psn-inr-1000.png": 5689,
	"./psn-inr-2000.png": 9527,
	"./psn-pl-100.png": 5830,
	"./psn-pl-200.png": 842,
	"./psn-pl-50.png": 2606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9262;